import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Dictionary from './pages/Dictionary';
import GroupView from './pages/GroupView';
import Versions from './pages/Versions';
import Import from './pages/Import';
import Settings from './pages/Settings';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dictionary" element={<Dictionary />} />
        <Route path="/groups/:groupId" element={<GroupView />} />
        <Route path="/versions" element={<Versions />} />
        <Route path="/import" element={<Import />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

export default App;

